import { useBackendApi } from './backendApi';
import { useEventsPublisher, useEventsSubscriber } from 'event-bus';

export const PROJECT_LINKS_UPDATED = 'PROJECT_LINKS_UPDATED';

export function useProjectLinkService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  useEventsSubscriber('projectLinkService', {
    [PROJECT_LINKS_UPDATED]: () => {
      // Handle any cache clearing or updates if needed
    }
  }, []);

  const removeLink = async (projectId: number, linkId: number): Promise<void> => {
    await nekstApi.delete(`/projects/${projectId}/externalprojectslinks/${linkId}`);
    eventsPublisher.publish(PROJECT_LINKS_UPDATED, {});
  };

  return {
    removeLink,
  };
} 